import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

let refreshOrderPaymentStatusCallable;
let generateTemporaryInvoicePdfCallable;

const getRefreshOrderPaymentStatusCallable = () => {
  if (!refreshOrderPaymentStatusCallable) {
    refreshOrderPaymentStatusCallable = httpsCallable(
      functions,
      "refreshOrderPaymentStatus"
    );
  }
  return refreshOrderPaymentStatusCallable;
};

const getGenerateTemporaryInvoicePdfCallable = () => {
  if (!generateTemporaryInvoicePdfCallable) {
    generateTemporaryInvoicePdfCallable = httpsCallable(
      functions,
      "generateTemporaryInvoicePdfForOrder"
    );
  }
  return generateTemporaryInvoicePdfCallable;
};

export const refreshOrderPaymentStatus = async (orderIds = []) => {
  if (!Array.isArray(orderIds) || orderIds.length === 0) {
    return { results: [] };
  }

  try {
    const callable = getRefreshOrderPaymentStatusCallable();
    const { data } = await callable({ orderIds });

    if (data && typeof data === "object") {
      if (
        Object.prototype.hasOwnProperty.call(data, "result") &&
        data.result
      ) {
        return data.result;
      }
      return data;
    }

    return {};
  } catch (err) {
    const message =
      err?.message ||
      (typeof err?.details === "string" ? err.details : null) ||
      (typeof err === "string" ? err : null) ||
      "Failed to refresh order payment status";
    throw new Error(message);
  }
};

export const generateTemporaryInvoicePdfForOrder = async (orderId) => {
  if (!orderId || typeof orderId !== "string") {
    throw new Error("A valid order ID is required.");
  }

  try {
    const callable = getGenerateTemporaryInvoicePdfCallable();
    const { data } = await callable({ orderId });
    return data || {};
  } catch (err) {
    const message =
      err?.message ||
      (typeof err?.details === "string" ? err.details : null) ||
      (typeof err === "string" ? err : null) ||
      "Failed to generate temporary invoice PDF";
    throw new Error(message);
  }
};
